import { Dictionary, strNumberCompare } from '.'

// 用户名
const nameReg = /^\w{2,16}$/
const usernameInvalidHint = '请输入合法的用户名, 支持字母和数字组合'
export const isValidUsername = (str: string) => nameReg.test(str.trim())

// 用户名
const sapNoReg = /^\w{6}$/
export const sapNoInvalidHint = '请输入6位SAP号, 支持字母和数字组合'
export const isValidSapNo = (str: string) => sapNoReg.test(str.trim())

const isSpecialChar = (str: string) => {
  return /^[`~!@#$%^&*()\-=_+[{\]};:'",<.>/?]$/.test(str.trim())
}

const isPureAlphabet = (str: string) => {
  return /^[a-zA-Z]+$/.test(str.trim()) // 正则写起来简洁, 下方的函数式可读性好一点
  // return str.split('').every(it => isAlpha(it))
}

const isPureNumber = (str: string) => {
  return /^[0-9]+$/.test(str.trim())
}

const isPureSpecialChar = (str: string) => {
  return str
    .split('')
    .map(isSpecialChar)
    .every((it) => it)
}

// 至少2种以上数字,字母,特殊字符的组合, 6-20位
// const passwordReg = new RegExp(/^[`~!@#$%^&*()\-=_+[{\]};:'",<.>/?\w]{6,20}$/)
const passwordReg = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).{6,20}$/)
export const passwordInvalidHint =
  '请输入6到20位的密码，必须含有数字与字母，可以输入特殊符号，不区分大小写'
export const isValidPassword = (str: string) => {
  if (isPureAlphabet(str)) {
    return false
  } else if (isPureNumber(str)) {
    return false
  } else if (isPureSpecialChar(str)) {
    return false
  } else {
    return passwordReg.test(str.trim())
  }
}

// 验证码
const captchaInvalidHint = '请输入正确的验证码'
export const isValidCaptcha = (str: string) => /^\w{4}$/.test(str.trim())

// 外部链接
export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

// id数值
export const stringNumberId = [
  {
    pattern: /^\d{0,}$/,
    message: '请输入正整数值'
  },
  {
    validator(rule: unknown, val: string, cb: Function) {
      const UPPER_LIMIT = '9223372036854775807'
      if (strNumberCompare(val, UPPER_LIMIT) === 1 || +val < 0) {
        cb(new Error('数值超过字段限制范围'))
      }
      cb()
    }
  }
]

/**
 * 返回表单规则validator
 * @param isValid 是否有效判断函数
 * @param hint 无效时的错误提示
 * @param revert 判断函数返回值是否取反进行判断
 * @returns
 */
export const getAsyncValidator =
  (isValid: (value: any) => boolean, hint: string, revert = false) =>
    (rule: unknown, value: string, callback: Function) => {
      let isValidResult = isValid(value)
      if (revert) isValidResult = !isValidResult

      if (!isValidResult) {
        callback(new Error(hint))
      } else {
        callback()
      }
    }

// 用于表单验证判断是否是纯空格格式
export const isEmptyTrimmedString = (value: string) => {
  if (typeof value !== 'string') {
    return false
  }
  return value.trim().length === 0
}
export const getIsEmptyTrimmedStringValidator = (hint: string) => {
  return getAsyncValidator(isEmptyTrimmedString, hint, true)
}

export const validators: Dictionary<any> = {
  password: getAsyncValidator(isValidPassword, passwordInvalidHint),
  username: getAsyncValidator(isValidUsername, usernameInvalidHint),
  sapNo: getAsyncValidator(isValidSapNo, sapNoInvalidHint),
  captcha: getAsyncValidator(isValidCaptcha, captchaInvalidHint),
  stringNumberId
}
